// extracted by mini-css-extract-plugin
export default {"errorList":"G12246b","errorListItem":"G59d228"};